/**
 * Stock Transfer Model - Processes API responses for stock transfer data
 */

/**
 * Process stock transfer list response data
 * @param {Object} response - API response from stock transfer list endpoint
 * @returns {Object} Formatted stock transfer list data
 */
export const stockTransferListGet = (response) => {
    if (response && response.data && response.data.success === true) {
        const data = response.data;
        return {
            success: true,
            message: data.message || 'Stock transfers retrieved successfully',
            total: data.total || (Array.isArray(data.data) ? data.data.length : 0),
            data: Array.isArray(data.data) ? data.data.map(transfer => ({
                id: transfer.id || null,
                slack: transfer.slack || null,
                store_id: transfer.store_id || null,
                stock_transfer_number: transfer.stock_transfer_number || null,
                stock_transfer_reference: transfer.stock_transfer_reference || null,
                from_store_id: transfer.from_store_id || null,
                from_store_code: transfer.from_store_code || null,
                from_store_name: transfer.from_store_name || null,
                to_store_id: transfer.to_store_id || null,
                to_store_code: transfer.to_store_code || null,
                to_store_name: transfer.to_store_name || null,
                requisition_id: transfer.requisition_id || null,
                notes: transfer.notes || null,
                total_transfer_value: transfer.total_transfer_value || '0',
                total_transfer_value_including_tax: transfer.total_transfer_value_including_tax || '0',
                status: transfer.status ?? 0,
                created_by: transfer.created_by || null,
                updated_by: transfer.updated_by || null,
                createdAt: transfer.createdAt || null,
                updatedAt: transfer.updatedAt || null,
                StockTransfer_status_data: {
                    id: transfer.StockTransfer_status_data?.id || null,
                    key: transfer.StockTransfer_status_data?.key || null,
                    value: transfer.StockTransfer_status_data?.value ?? '0',
                    value_constant: transfer.StockTransfer_status_data?.value_constant || null,
                    label: transfer.StockTransfer_status_data?.label || 'N/A',
                    color: transfer.StockTransfer_status_data?.color || null,
                    status: transfer.StockTransfer_status_data?.status ?? 0,
                    createdAt: transfer.StockTransfer_status_data?.createdAt || null,
                    updatedAt: transfer.StockTransfer_status_data?.updatedAt || null
                },
                StockTransfer_CreatedUser: {
                    id: transfer.StockTransfer_CreatedUser?.id || null,
                    profile_img_url: transfer.StockTransfer_CreatedUser?.profile_img_url || null,
                    first_name: transfer.StockTransfer_CreatedUser?.first_name || null,
                    last_name: transfer.StockTransfer_CreatedUser?.last_name || null,
                    contact_number: transfer.StockTransfer_CreatedUser?.contact_number || null,
                    email: transfer.StockTransfer_CreatedUser?.email || null,
                    is_active: transfer.StockTransfer_CreatedUser?.is_active ?? false,
                    createdAt: transfer.StockTransfer_CreatedUser?.createdAt || null,
                    updatedAt: transfer.StockTransfer_CreatedUser?.updatedAt || null
                },
                StockTransfer_UpdatedUser: {
                    id: transfer.StockTransfer_UpdatedUser?.id || null,
                    profile_img_url: transfer.StockTransfer_UpdatedUser?.profile_img_url || null,
                    first_name: transfer.StockTransfer_UpdatedUser?.first_name || null,
                    last_name: transfer.StockTransfer_UpdatedUser?.last_name || null,
                    contact_number: transfer.StockTransfer_UpdatedUser?.contact_number || null,
                    email: transfer.StockTransfer_UpdatedUser?.email || null,
                    is_active: transfer.StockTransfer_UpdatedUser?.is_active ?? false,
                    createdAt: transfer.StockTransfer_UpdatedUser?.createdAt || null,
                    updatedAt: transfer.StockTransfer_UpdatedUser?.updatedAt || null
                },
                StockTransfer_Store: {
                    id: transfer.StockTransfer_Store?.id || null,
                    org_id: transfer.StockTransfer_Store?.org_id || null,
                    slack: transfer.StockTransfer_Store?.slack || null,
                    store_code: transfer.StockTransfer_Store?.store_code || null,
                    store_type: transfer.StockTransfer_Store?.store_type || null,
                    name: transfer.StockTransfer_Store?.name || null,
                    address: transfer.StockTransfer_Store?.address || null,
                    country_id: transfer.StockTransfer_Store?.country_id || null,
                    state_code: transfer.StockTransfer_Store?.state_code || null,
                    state: transfer.StockTransfer_Store?.state || null,
                    pincode: transfer.StockTransfer_Store?.pincode || null,
                    primary_contact: transfer.StockTransfer_Store?.primary_contact || null,
                    secondary_contact: transfer.StockTransfer_Store?.secondary_contact || null,
                    primary_email: transfer.StockTransfer_Store?.primary_email || null,
                    secondary_email: transfer.StockTransfer_Store?.secondary_email || null,
                    invoice_type: transfer.StockTransfer_Store?.invoice_type || null,
                    currency_name: transfer.StockTransfer_Store?.currency_name || null,
                    currency_code: transfer.StockTransfer_Store?.currency_code || null,
                    restaurant_mode: transfer.StockTransfer_Store?.restaurant_mode ?? 0,
                    is_procurement_hub: transfer.StockTransfer_Store?.is_procurement_hub ?? 0,
                    can_sell: transfer.StockTransfer_Store?.can_sell ?? 0,
                    is_primary: transfer.StockTransfer_Store?.is_primary ?? false,
                    parent_store_id: transfer.StockTransfer_Store?.parent_store_id || null,
                    status: transfer.StockTransfer_Store?.status ?? 0,
                    createdAt: transfer.StockTransfer_Store?.createdAt || null,
                    updatedAt: transfer.StockTransfer_Store?.updatedAt || null
                },
                StockTransfer_FromStore: {
                    id: transfer.StockTransfer_FromStore?.id || null,
                    store_code: transfer.StockTransfer_FromStore?.store_code || null,
                    store_type: transfer.StockTransfer_FromStore?.store_type || null,
                    name: transfer.StockTransfer_FromStore?.name || null,
                    address: transfer.StockTransfer_FromStore?.address || null,
                    state: transfer.StockTransfer_FromStore?.state || null,
                    state_code: transfer.StockTransfer_FromStore?.state_code || null,
                    pincode: transfer.StockTransfer_FromStore?.pincode || null,
                    currency_code: transfer.StockTransfer_FromStore?.currency_code || null,
                    is_procurement_hub: transfer.StockTransfer_FromStore?.is_procurement_hub ?? 0,
                    can_sell: transfer.StockTransfer_FromStore?.can_sell ?? 0,
                    is_primary: transfer.StockTransfer_FromStore?.is_primary ?? false,
                    status: transfer.StockTransfer_FromStore?.status ?? 0,
                    createdAt: transfer.StockTransfer_FromStore?.createdAt || null,
                    updatedAt: transfer.StockTransfer_FromStore?.updatedAt || null
                },
                StockTransfer_ToStore: {
                    id: transfer.StockTransfer_ToStore?.id || null,
                    store_code: transfer.StockTransfer_ToStore?.store_code || null,
                    store_type: transfer.StockTransfer_ToStore?.store_type || null,
                    name: transfer.StockTransfer_ToStore?.name || null,
                    address: transfer.StockTransfer_ToStore?.address || null,
                    state: transfer.StockTransfer_ToStore?.state || null,
                    state_code: transfer.StockTransfer_ToStore?.state_code || null,
                    pincode: transfer.StockTransfer_ToStore?.pincode || null,
                    currency_code: transfer.StockTransfer_ToStore?.currency_code || null,
                    is_procurement_hub: transfer.StockTransfer_ToStore?.is_procurement_hub ?? 0,
                    can_sell: transfer.StockTransfer_ToStore?.can_sell ?? 0,
                    is_primary: transfer.StockTransfer_ToStore?.is_primary ?? false,
                    status: transfer.StockTransfer_ToStore?.status ?? 0,
                    createdAt: transfer.StockTransfer_ToStore?.createdAt || null,
                    updatedAt: transfer.StockTransfer_ToStore?.updatedAt || null
                },
                transfer_products: Array.isArray(transfer.transfer_products)
                    ? transfer.transfer_products.map(tp => ({
                        id: tp.id || null,
                        slack: tp.slack || null,
                        stock_transfer_id: tp.stock_transfer_id || null,
                        product_id: tp.product_id || null,
                        product_slack: tp.product_slack || null,
                        product_code: tp.product_code || null,
                        product_name: tp.product_name || null,
                        quantity: tp.quantity || '0',
                        inward_type: tp.inward_type || null,
                        accepted_quantity: tp.accepted_quantity || null,
                        transfer_price: tp.transfer_price || '0',
                        tax_amount: tp.tax_amount || '0',
                        destination_product_id: tp.destination_product_id || null,
                        destination_product_slack: tp.destination_product_slack || null,
                        destination_product_code: tp.destination_product_code || null,
                        destination_product_name: tp.destination_product_name || null,
                        status: tp.status ?? 0,
                        created_by: tp.created_by || null,
                        updated_by: tp.updated_by || null,
                        createdAt: tp.createdAt || null,
                        updatedAt: tp.updatedAt || null,
                        Product: tp.Product ? {
                            id: tp.Product.id || null,
                            slack: tp.Product.slack || null,
                            store_id: tp.Product.store_id || null,
                            product_code: tp.Product.product_code || null,
                            name: tp.Product.name || null,
                            description: tp.Product.description || null,
                            product_type: tp.Product.product_type || null,
                            category_id: tp.Product.category_id || null,
                            unit_of_measure: tp.Product.unit_of_measure || null,
                            quantity: tp.Product.quantity || '0',
                            alert_quantity: tp.Product.alert_quantity || '0',
                            purchase_amount_excluding_tax: tp.Product.purchase_amount_excluding_tax || '0',
                            sale_amount_excluding_tax: tp.Product.sale_amount_excluding_tax || '0',
                            sale_amount_including_tax: tp.Product.sale_amount_including_tax || '0',
                            is_inventory_manage: tp.Product.is_inventory_manage ?? 0,
                            is_ingredient: tp.Product.is_ingredient ?? 0,
                            is_purchasable: tp.Product.is_purchasable ?? 0,
                            status: tp.Product.status ?? 0,
                            tax_code_id: tp.Product.tax_code_id || null,
                            discount_code_id: tp.Product.discount_code_id || null,
                            preferred_supplier_id: tp.Product.preferred_supplier_id || null,
                            supplier_ids: tp.Product.supplier_ids || null,
                            createdAt: tp.Product.createdAt || null,
                            updatedAt: tp.Product.updatedAt || null
                        } : null,
                        DestinationProduct: tp.DestinationProduct ? {
                            id: tp.DestinationProduct.id || null,
                            slack: tp.DestinationProduct.slack || null,
                            store_id: tp.DestinationProduct.store_id || null,
                            product_code: tp.DestinationProduct.product_code || null,
                            name: tp.DestinationProduct.name || null,
                            description: tp.DestinationProduct.description || null,
                            product_type: tp.DestinationProduct.product_type || null,
                            category_id: tp.DestinationProduct.category_id || null,
                            unit_of_measure: tp.DestinationProduct.unit_of_measure || null,
                            quantity: tp.DestinationProduct.quantity || '0',
                            alert_quantity: tp.DestinationProduct.alert_quantity || '0',
                            purchase_amount_excluding_tax: tp.DestinationProduct.purchase_amount_excluding_tax || '0',
                            sale_amount_excluding_tax: tp.DestinationProduct.sale_amount_excluding_tax || '0',
                            sale_amount_including_tax: tp.DestinationProduct.sale_amount_including_tax || '0',
                            is_inventory_manage: tp.DestinationProduct.is_inventory_manage ?? 0,
                            is_ingredient: tp.DestinationProduct.is_ingredient ?? 0,
                            is_purchasable: tp.DestinationProduct.is_purchasable ?? 0,
                            status: tp.DestinationProduct.status ?? 0,
                            tax_code_id: tp.DestinationProduct.tax_code_id || null,
                            discount_code_id: tp.DestinationProduct.discount_code_id || null,
                            createdAt: tp.DestinationProduct.createdAt || null,
                            updatedAt: tp.DestinationProduct.updatedAt || null
                        } : null
                    }))
                    : []
            })) : []
        };
    }
    return {
        success: false,
        message: response?.data?.message || 'Failed to fetch stock transfer list',
        data: []
    };
};

/**
 * Process stock transfer creation response
 * @param {Object} response - API response from stock transfer create endpoint
 * @returns {Object} Formatted creation response
 */
export const stockTransferCreatePost = (response) => {
    // Based on Postman collection response format
    if (response && response.data) {
        return {
            success: response.data.success === true,
            message: response.data.message || 'Stock transfer created successfully',
            data: response.data.data || null
        };
    }
    return {
        success: false,
        message: 'Failed to create stock transfer',
        data: null
    };
};

/**
 * Process single stock transfer details response
 * @param {Object} response - API response from stock transfer details endpoint
 * @returns {Object} Formatted stock transfer details
 */
export const stockTransferDetailsGet = (response) => {
    // Based on Postman collection response format
    if (response && response.data && response.data.success === true) {
        const item = response.data.data || {};
        return {
            success: true,
            data: item
        };
    }
    return {
        success: false,
        message: response?.data?.message || 'Failed to fetch stock transfer details',
        data: {}
    };
};

/**
 * Process stock transfer update response
 * @param {Object} response - API response from stock transfer update endpoint
 * @returns {Object} Formatted update response
 */
export const stockTransferUpdatePut = (response) => {
    // Based on Postman collection response format
    if (response && response.data) {
        return {
            success: response.data.success === true,
            message: response.data.message || 'Stock transfer updated successfully',
            data: response.data.data || null
        };
    }
    return {
        success: false,
        message: 'Failed to update stock transfer',
        data: null
    };
};

/**
 * Process stock transfer delete response
 * @param {Object} response - API response from stock transfer delete endpoint
 * @returns {Object} Formatted delete response
 */
export const stockTransferDeleteDel = (response) => {
    // Based on Postman collection response format
    if (response && response.data) {
        return {
            success: response.data.success === true,
            message: response.data.message || 'Stock transfer deleted successfully'
        };
    }
    return {
        success: false,
        message: 'Failed to delete stock transfer'
    };
};

/**
 * Process store list response data
 * @param {Object} response - API response from store list endpoint
 * @returns {Object} Formatted store list data
 */
export const storeListGet = (response) => {
    // Based on Postman collection response format
    if (response && response.data && response.data.success === true) {
        return {
            success: true,
            total: response.data.total || response.data.data.length,
            data: response.data.data
        };
    }
    return {
        success: false,
        message: response?.data?.message || 'Failed to fetch store list',
        data: []
    };
};

/**
 * Process stock transfer dispatch response
 * @param {Object} response - API response from stock transfer dispatch endpoint
 * @returns {Object} Formatted dispatch response
 */
export const stockTransferDispatchPost = (response) => {
    if (response && response.data) {
        return {
            success: response.data.success === true || response.status === 200,
            message: response.data.message || 'Stock transfer dispatched successfully',
            data: response.data.data || null
        };
    }
    return {
        success: false,
        message: 'Failed to dispatch stock transfer',
        data: null
    };
};